export default "__VITE_ASSET__413f5a33__"